import PropTypes from 'prop-types';
import {useEffect, useState} from 'react';
import Header, {headerItemsLabels} from '../Common/Header/header';
import useLabels from 'infrastructure/js/hooks/useLabels';
import ShipmentLotsGrid from './ShipmentLotsGrid/shipmentLotsGrid';
import DateTimeHelper from 'infrastructure/js/utils/dateTimeHelper';
import NameValuePairs from '../Common/NameValuePairs/nameValuePairs';
import {enumTypes, getEnumLabel} from '../../utils/enumHelper';

import './shipmentPage.scss';


const getShipmentDetailsInitialData = (data, labels) => {
  return (
    [
      {label: labels.get('shipment'), value: data?.businessId ?? ''},
      { label: labels.get('status'), value: getEnumLabel(enumTypes.SHIPMENT_STATUS)(data?.status)  ?? ''},
      { label: labels.get('createdDate'), value: DateTimeHelper.DateTimeFormat(data?.createdDate?.epochDateTime * 1000)},
      { label: labels.get('createdBy'), value: data?.createdByUser ?? ''},
    ]);
}


export default function ShipmentPage({ history,
                                       match,
                                       initialData=null,
                                       actions,
                                     }) {
  const labels = useLabels('mat.shipment.cocSummary.');
  const [shipmentDetails, setShipmentDetails] = useState([]);

  useEffect(() => {
    const details = getShipmentDetailsInitialData(initialData, labels);

    setShipmentDetails(details);

  }, [initialData]);


  const getHeaderItems = () => {
    return {
      title: labels.get('header.title'),
      buttons: [
        {
          id: 'clearFilters',
          label: '',
          icon: 'pl pl-filter-clear',
          action: actions.shipmentPageActions.clearFilters,
          tooltip: headerItemsLabels.CLEAR_FILTERS,
        },
        {
          id: 'refresh',
          label: '',
          icon: 'pl pl-refresh',
          action: actions.shipmentPageActions.reload,
          tooltip: headerItemsLabels.REFRESH,
        },
      ],
    }
  }

    return initialData ? (
      <div className='shipment-page'>

        <div className='shipment-details-section'>
          <NameValuePairs items={shipmentDetails}/>
        </div>

        <Header {...getHeaderItems()}/>

        <ShipmentLotsGrid
          history={history}
          match={match}
          actions={{...actions.shipmentLotsGridActions, ...actions.fetchEntitiesActions}}/>
      </div>
    ) : null;
}


ShipmentPage.propTypes = {
  history: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
  initialData: PropTypes.object,
  actions: PropTypes.object.isRequired,
};
